import { useState, useEffect } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import Panel from "../../../components/panel/panel";
import ExportTable from "../../../components/button/ExportButton";
import { formatDate } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/formatCurrency";

export const Table = ({
  table,
  setItemsSelected,
  itemsSelected,
  isLoading,
}) => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [tableToExport, setTableToExport] = useState(null);

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const columns = [
    { field: "id", header: `Código` },
    { field: "sequence_number", header: `N° Parcela` },
    {
      field: "client",
      header: `Cliente`,
    },
    {
      field: "desc",
      header: "Descrição",
    },
    {
      field: "enterprise",
      header: "Empreendimento",
    },
    {
      field: "status",
      header: "Situação",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "A Vencer";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Pago";
            break;
          case 2:
            labelClass = "badge bg-success";
            labelText = "todos";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
    {
      field: "block",
      header: "Q/L",
    },
    {
      field: "due_date",
      header: "Data de Vencimento",
      body: (rowData) => rowData.due_date && formatDate(rowData.due_date),
    },
    {
      field: "value",
      header: "Valor Parcela",
      body: (rowData) => rowData.value && formatCurrency(rowData.value),
    },
    {
      field: "payment_date",
      header: "Data Recebimento",
      body: (rowData) =>
        rowData.payment_date && formatDate(rowData.payment_date),
    },
    {
      field: "discount",
      header: "Desconto",
    },
    {
      field: "fine",
      header: "Acréscimo",
    },
    {
      field: "payment_method",
      header: "Forma de Pagamento",
    },
    {
      field: "released_by",
      header: "Lançado por",
    },
    {
      field: "completed_by",
      header: "Baixado por",
    },
  ];

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onSelectionChange = (event) => {
    const value = event.value;
    setItemsSelected(value);
  };

  useEffect(() => {
    if (table) {
      const dataWithoutIds = table.map((t) => {
        let labelText = "";
        switch (t.status) {
          case 0:
            labelText = "Em Aberto";
            break;
          case 1:
            labelText = "Pago";
            break;
          case 2:
            labelText = "Ib Juridico";
            break;
          case 3:
            labelText = "Em Renegociação";
            break;
          default:
        }

        return {
          Codigo: t.id,
          NumeroParcela: t.sequence_number,
          Cliente: t.client,
          Descricao: t.desc,
          Empreendimento: t.enterprise,
          Situacao: labelText,
          QuadraLote: t.block,
          DataVencimento: t.due_date,
          ValorParcela: t.value,
          DataRecebimento: t.payment_date,
          Desconto: t.discunt,
          Acrescimo: t.fine,
          FormaPagamento: t.payment_method,
          LancadoPor: t.released_by,
          BaixadoPor: t.completed_by,
        };
      });
      setTableToExport(dataWithoutIds);
    }
  }, [table]);

  return (
    <Panel title="Estornos no Período" mainCss="mt-4">
      <ExportTable
        tableData={tableToExport}
        exportColumns={exportColumns}
        tabelaKey="Estornos no Período"
        globalFilterValue={globalFilterValue}
        onGlobalFilterChange={onGlobalFilterChange}
      />
      <DataTable
        loading={isLoading}
        stripedRows
        showGridlines
        sortMode="multiple"
        selectionMode="multiple"
        value={table}
        selection={itemsSelected}
        onSelectionChange={onSelectionChange}
        emptyMessage="Nenhuma Informação foi encontrada."
        tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
      >
        <Column key="selected" field="select" selectionMode="multiple" />
        {columns.map((col) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            body={col.body}
          />
        ))}
      </DataTable>
    </Panel>
  );
};
